import type { TLang } from "@litres-libs/types";
import az from "./data/az";
import de from "./data/de";
import en from "./data/en";
import es from "./data/es";
import et from "./data/et";
import pl from "./data/pl";
import uz from "./data/uz";
import tr from "./data/tr";
import ru from "./data/ru";

import { useUIKitContext } from "../settings";

export type TLocaleFunc = (value: any) => string;

function getLocale(
  lang: TLang
): Record<string, string | TLocaleFunc | undefined> {
  switch (lang) {
    case "az-AZ": {
      return az;
    }
    case "de-DE": {
      return de;
    }
    case "en-US": {
      return en;
    }
    case "es-ES": {
      return es;
    }
    case "et-EE": {
      return et;
    }
    case "pl-PL": {
      return pl;
    }
    case "uz-UZ": {
      return uz;
    }
    case "tr-TR": {
      return tr;
    }
    default: {
      return ru;
    }
  }
}

export const useLocale = () => {
  const { lang } = useUIKitContext();
  const currentLocale = getLocale(lang);
  const t = (key: string, value?: any) => {
    const dataFromLocale: string | undefined | TLocaleFunc = currentLocale[key];
    if (typeof dataFromLocale === "function") {
      return dataFromLocale(value);
    }
    if (typeof dataFromLocale === "string") {
      return dataFromLocale;
    }
    console.error(`Missing translations, ${lang},`, key);
    return key;
  };
  return {
    lang,
    t,
  };
};
